import type { ConversationMessage } from "@/stores/conversation-store";
import { translate } from "@/i18n";
import { libChatMessages } from "@/i18n/messages/lib-chat";

const NOTICE_TITLE = /^Background task result available: ([^\n]*)/;

/** Identity of a native sub-agent result notice, or undefined for any other message. */
export function nativeResultNotice(
  metadata: Record<string, unknown> | undefined,
  content: string,
): ConversationMessage["backgroundResult"] {
  if (metadata?.source !== "native_subagent_result") return undefined;
  const taskId =
    typeof metadata.task_id === "string" && metadata.task_id
      ? metadata.task_id
      : null;
  const storedTitle =
    typeof metadata.task_title === "string" ? metadata.task_title : "";
  return {
    taskId,
    title:
      storedTitle ||
      (NOTICE_TITLE.exec(content)?.[1] ??
        translate(libChatMessages, "backgroundTask")),
  };
}
